export const MESSAGE = 'Não foi possível carregar os produtos, tente novamente.'
export const SEARCH_MESSAGE = 'Desculpe, não encontramos nenhum resultado para'
